import React from 'react';
import Icon from '../../../components/AppIcon';

const EngagementMetricCard = ({ title, value, change, changeType, icon, iconColor, trend }) => {
  const isPositive = changeType === 'positive';
  const isNegative = changeType === 'negative';
  
  return (
    <div className="bg-card rounded-lg p-6 border border-border shadow-sm hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <p className="text-sm font-medium text-muted-foreground mb-1">{title}</p>
          <h3 className="text-3xl font-bold text-foreground">{value}</h3>
        </div>
        <div className={`p-3 rounded-lg ${iconColor}`}>
          <Icon name={icon} size={24} color="white" />
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Icon 
            name={isPositive ? 'TrendingUp' : isNegative ? 'TrendingDown' : 'Minus'} 
            size={16} 
            className={isPositive ? 'text-success' : isNegative ? 'text-error' : 'text-muted-foreground'}
          />
          <span className={`text-sm font-medium ${isPositive ? 'text-success' : isNegative ? 'text-error' : 'text-muted-foreground'}`}>
            {change}
          </span>
          <span className="text-sm text-muted-foreground">vs last period</span>
        </div>
      </div>
      {trend && (
        <div className="mt-4 h-12 flex items-end gap-1">
          {trend?.map((value, index) => (
            <div 
              key={index}
              className="flex-1 bg-primary/20 rounded-t"
              style={{ height: `${value}%` }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default EngagementMetricCard;